import { ADD_AGENT_BRAND } from '../../endpoints';
import { IAgentBrand } from '../../types/agent';    
import makeAuthenticatedRequest from '../base-api';

const addAgentBrandApiQueryKey = (agentId: string) => ['agent-brand', agentId];

const addAgentBrandApi = async (data: IAgentBrand): Promise<IAgentBrand> => {
  try {
    const response = await makeAuthenticatedRequest(ADD_AGENT_BRAND, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    const result = await response.json();

    if (!result.success) {
      throw new Error(result.message);
    }

    return result;  
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export { addAgentBrandApi, type IAgentBrand, addAgentBrandApiQueryKey };